export default {
    _prefix: "Scoring",
    labels: {
        GroupTitleIndex: (data: { groupIndex: number }) =>
            "Group {{groupIndex}}",
        Points: "Points {{#ScoreTag}}{{/ScoreTag}}",
        ScaledPoints: "Scaled Points {{#ScoreTag}}{{/ScoreTag}}",
        ScalingFactor: "Scaling Factor",
        FlipSwitch: {
            GroupScaledScoringOn: "Scaled Scoring On",
            GroupScaledScoringOff: "Scaled Scoring Off",
        },
        ariaLabels: {
            totalPoints: (data: { value: number }) => "Total Points: {{value}}",
            scaledTotalPoints: (data: { value: number }) =>
                "Scaled Total Points: {{value}}",
        },
    },
};
